// extracted by css-extract-rspack-plugin
export default {"smartLink":"OYDJv","userMention":"eOWQI","icon":"ZMMYf","smartLinkInner":"P2F9q"};